import { createContext, useContext, useState } from 'react';

const PurchaseContext = createContext({});

export function PurchaseProvider({ children }) {
  const initialPurchaseInfo = {
    quantity: '',
    reservationId: '',
    // default to credit card options - if crypto update purchase time when updating currency
    isCreditCardPurchase: true,
    purchaseCurrency1: 'USD',
    purchaseCurrency2: '',
    memo: ''
  };
  const [purchaseInfo, setPurchaseInfo] = useState(initialPurchaseInfo);

  return (
    <PurchaseContext.Provider
      value={{
        purchaseInfo,
        setPurchaseInfo
      }}
    >
      {children}
    </PurchaseContext.Provider>
  );
}

function usePurchase() {
  return useContext(PurchaseContext);
}

export default usePurchase;
